import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';

// A stable refresh function plus cancellation prevents older requests overwriting newer data.
export function useApiResource<T>(path: string, initial: T) {
  const [data, setData] = useState<T>(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const pending = useRef<AbortController | null>(null);
  const refresh = useCallback(async () => {
    pending.current?.abort();
    const controller = new AbortController();
    pending.current = controller;
    setError('');
    setLoading(true);
    try {
      const result = await api<T>(path, 'GET', undefined, controller.signal);
      if (!controller.signal.aborted) setData(result);
    } catch (error: any) {
      if (!controller.signal.aborted) setError(error.message);
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    void refresh();
    return () => pending.current?.abort();
  }, [refresh]);
  return {data, setData, loading, error, setError, refresh};
}